import { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import products from './products.json';
import AddressPage from '../src/Rydercup/pages/AddressPage.jsx';
import BundlePage from '../src/Rydercup/pages/BundlePage.jsx';
import ItemSelectionPage from '../src/Rydercup/pages/ItemSelectionPage.jsx';
import ConfirmationPage from '../src/Rydercup/pages/ConfirmationPage.jsx';
import BundleDetailsPage from '../src/Rydercup/pages/BundleDetailsPage.jsx';
import ItemDetailPage from '../src/Rydercup/pages/ItemDetailPage.jsx';
import ProductPage from '../src/Rydercup/pages/ProductPage.jsx';
import RedemptionForm from './Redemption/RedemptionForm.jsx'
import SalesDashboard from './SalesDashboard/SalesDashboard.jsx'
import OrderLookupPage from './OrderHistoryS1/pages/OrderLooupPage.jsx'
import JobLookup from './FacilisToHubSpot/pages/JobLookupPage.jsx'
import HRJacketsPage from './UsapJackets/pages/HRJacketsPage.jsx'
import LandstarSafetyRedemptionPage from './LandstarSafetyRedemption/pages/LandstarSafetyRedemptionPage.jsx'
import LandstarOrderConfirmationPage from './LandstarSafetyRedemption/pages/LandstarOrderConfirmationPage.jsx'
import LandstarEligibilityImportPage from './LandstarSafetyRedemption/pages/LandstarEligibilityImportPage.jsx'
import CologuardPage from './Cologuard/index.js'
import CologuardAuthProvider from './Cologuard/auth/CologuardAuthProvider.jsx'
import SanmarTrackingLookup from './SanmarTrackingLookup/Lookup.jsx'
import {
  CologuardHistoryRoute,
  CologuardCampaignDetailRoute,
  CologuardInstructionsRoute,
  CologuardSetupRoute,
  CologuardSummaryRoute,
  CologuardUsersRoute,
} from './Cologuard/pages/OutletPages.jsx'
import AccessDeniedPage from './index.jsx'

const pageTitles = {
  '/': 'Access Denied',
  '/rydercup': 'Ryder Cup',
  '/address': 'Address',
  '/bundles': 'Bundles',
  '/items': 'Item Selection',
  '/confirmation': 'Confirmation',
  '/nexeo': 'Nexeo',
  '/badger-vet': 'Badger Vet',
  '/sales-dashboard': 'Sales Dashboard',
  '/order-history-s1': 'Order History',
  '/facilis-to-hubspot': 'Facilis To HubSpot',
  '/usap-jackets': 'USAP Jackets',
  '/cologuard': 'Cologuard Code Generation',
  '/sanmar-tracking-lookup': 'SanMar Tracking Lookup',
  '/cologuard-generate-codes': 'Cologuard Code Generation',
  '/landstar-safety-redemption': 'Landstar Safety Awards',
  '/landstar-safety-redemption/confirmation': 'Landstar Order Confirmation',
  '/landstar-safety-redemption/import-eligibility': 'Landstar Eligibility Import',
};

function ExternalRedirect() {
  useEffect(() => {
    window.location.href = 'https://main.d2lejun4ehbjt3.amplifyapp.com/';
  }, []);

  return null;
}

function CologuardRoute() {
  return (
    <CologuardAuthProvider>
      <CologuardPage />
    </CologuardAuthProvider>
  );
}

function AppRoutes({ userInfo, updateUserInfo, cart, updateCart, resetCart }) {
  const location = useLocation();

  useEffect(() => {
    const matchedTitle =
      pageTitles[location.pathname] ||
      (location.pathname.startsWith('/cologuard/users') ? 'Cologuard User Management' : null) ||
      (location.pathname.startsWith('/cologuard/instructions') ? 'Cologuard Instructions' : null) ||
      (location.pathname.startsWith('/cologuard/setup') ? 'Cologuard Campaign Setup' : null) ||
      (location.pathname.startsWith('/cologuard/history') ? 'Cologuard History' : null) ||
      (location.pathname.startsWith('/cologuard/campaigns/') ? 'Cologuard Campaign Detail' : null) ||
      (location.pathname.startsWith('/cologuard-generate-codes/setup')
        ? 'Cologuard Campaign Setup'
        : null) ||
      (location.pathname.startsWith('/cologuard-generate-codes/history')
        ? 'Cologuard History'
        : null) ||
      (location.pathname.startsWith('/cologuard-generate-codes/users')
        ? 'Cologuard User Management'
        : null) ||
      (location.pathname.startsWith('/item/') ? 'Item Details' : null) ||
      (location.pathname.startsWith('/bundle/') ? 'Bundle Details' : null) ||
      'Stran Store';

    document.title = matchedTitle;
  }, [location.pathname]);

  return (
    <Routes>
      <Route path="/" element={<AccessDeniedPage/>}/>
      <Route path="/rydercup"
        element={
          <ProductPage
            products={products}
          />
        } />
      <Route
        path="/address"
        element={<AddressPage userInfo={userInfo} updateUserInfo={updateUserInfo} />}
      />
      <Route
        path="/bundles"
        element={<BundlePage products={products} cart={cart} updateCart={updateCart} />}
      />
      <Route
        path="/item/:id"
        element={<ItemDetailPage cart={cart} updateCart={updateCart} />}
      />
      <Route
        path="/bundle/:id"
        element={
          <BundleDetailsPage
            cart={cart}
            updateCart={updateCart}
          />
        }
      />
      <Route
        path="/items"
        element={
          <ItemSelectionPage
            products={products}
            cart={cart}
            updateCart={updateCart}
          />
        }
      />
      <Route
        path="/confirmation"
        element={
          <ConfirmationPage
            userInfo={userInfo}
            cart={cart}
            resetCart={resetCart}
            products={products}
          />
        }
      />
      <Route
        path="/nexeo"
        element={
          <ProductPage
            products={products}
          />
        }
      />
      <Route
        path="/kprecruiting" 
        element={<ExternalRedirect />}
      />
      <Route
        path="/badger-vet" 
        element={<RedemptionForm />}
      />
      <Route
        path="/sales-dashboard"
        element={<SalesDashboard />}
      />
      <Route
        path="/order-history-s1"
        element={<OrderLookupPage />}
      />
      <Route
        path="/facilis-to-hubspot"
        element={<JobLookup />}
      />
      <Route 
        path="/usap-jackets"
        element={ <HRJacketsPage />}
      />
      <Route path="/cologuard" element={<CologuardRoute />}>
        <Route index element={<CologuardSummaryRoute />} />
        <Route path="auth/callback" element={<CologuardSummaryRoute />} />
        <Route path="setup" element={<CologuardSetupRoute />} />
        <Route path="history" element={<CologuardHistoryRoute />} />
        <Route path="campaigns/:campaignId" element={<CologuardCampaignDetailRoute />} />
        <Route path="users" element={<CologuardUsersRoute />} />
        <Route path="instructions" element={<CologuardInstructionsRoute />} />
      </Route>
      <Route path="/sanmar-tracking-lookup" element={<SanmarTrackingLookup apiBaseUrl={window.appConfig?.sanmarTrackingApiBaseUrl || 'https://ofm.stran.store/api/sanmar-tracking-lookup'} />} />
      <Route
        path="/landstar-safety-redemption"
        element={<LandstarSafetyRedemptionPage />}
      />
      <Route
        path="/landstar-safety-redemption/confirmation"
        element={<LandstarOrderConfirmationPage />}
      />
      <Route
        path="/landstar-safety-redemption/import-eligibility"
        element={<LandstarEligibilityImportPage />}
      />
    </Routes>
  );
}


function App() {
  const [userInfo, setUserInfo] = useState({
    name: '',
    address: '',
    email: '',
    phone: ''
  });

  const [cart, setCart] = useState({
    bundle: null,
    firstChoice: { items: [] },
    secondChoice: { items: [] },
    thirdChoice: { items: [] }
  });

  const updateUserInfo = (info) => {
    setUserInfo(info);
  };

  /* const updateCart = (key, value) => {
    setCart(prev => ({ ...prev, [key]: value }));
  }; */
  const updateCart = (newCart) => {
    console.log('Updating cart:', newCart); // Debug log
    setCart(newCart);
  };

  const resetCart = () => {
    setCart({
      bundle: null,
      firstChoice: null,
      secondChoice: null,
      thirdChoice: null
    });
  };

  return (
    <Router>
      <AppRoutes
        userInfo={userInfo}
        updateUserInfo={updateUserInfo}
        cart={cart}
        updateCart={updateCart}
        resetCart={resetCart}
      />
    </Router>
  );
}

export default App;
